import { useTranslation } from 'react-i18next';
import PhotovoltaicSVG from '../../../../assets/images/projectSimulator/PhotovoltaicSVG';
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  RadioGroup,
  Radio,
} from '@material-ui/core';
import { Controller, UseFormReturn } from 'react-hook-form';
import { InputProjectSimulator } from '../ProjectSimulator';
import { ListValueProps } from '../utils';

type PhotovoltaicAndExploitationProps = {
  photovoltaic: PhotovoltaicData;
  exploitation: ExploitationData;
  form: UseFormReturn;
};

export type PhotovoltaicData = {
  panelArea: number;
};

export type ExploitationData = {
  production: {
    list: ListValueProps[];
    value: number;
  };
};

function PhotovoltaicAndExploitation({
  photovoltaic,
  exploitation,
  form,
}: PhotovoltaicAndExploitationProps) {
  const { t } = useTranslation();
  const radioValuesOfExploitation: ListValueProps[] = Object.values(
    exploitation.production.list
  );
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        rowGap: '24px',
      }}
    >
      <div className="form-block">
        <h2 className="form-title">
          {t('APP.PROJECT.SIMULATOR.ADVANCED_CONCEPTION.PHOTOVOLTAIC.TITLE', {
            defaultValue: 'Photovoltaïque',
          })}
        </h2>
        <hr className="line-title-separation" />

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            paddingLeft: '24px',
          }}
        >
          <label className="form-label">
            {t('APP.PROJECT.SIMULATOR.ADVANCED_CONCEPTION.FORM.LABEL.PANEL_AREA', {
              defaultValue: 'Surface de panneaux (m²)',
            })}
          </label>
          <InputProjectSimulator
            form={form}
            name="panelArea"
            defaultValue={photovoltaic.panelArea}
            style={{ width: '30%', marginTop: '4px', marginBottom: '16px' }}
          />

          <div style={{ alignSelf: 'center' }}>
            <PhotovoltaicSVG />
          </div>
        </div>
      </div>

      <div className="form-block">
        <h2 className="form-title">
          {t('APP.PROJECT.SIMULATOR.ADVANCED_CONCEPTION.EXPLOITATION.TITLE', {
            defaultValue: 'Exploitation',
          })}
        </h2>
        <hr className="line-title-separation" style={{ paddingRight: '260px' }} />

        <Controller
          control={form.control}
          name="productionOfExploitation"
          defaultValue={exploitation.production.value}
          render={({ field }) => (
            <FormControl
              style={{
                paddingLeft: '24px',
              }}
            >
              <FormLabel>
                <p className="form-radio-control-label">
                  {t(
                    'APP.PROJECT.SIMULATOR.ADVANCED_CONCEPTION.FORM.LABEL.PRODUCTION',
                    {
                      defaultValue: 'Production',
                    }
                  )}
                </p>
              </FormLabel>
              <RadioGroup
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                }}
                {...field}
                value={
                  isNaN(field.value)
                    ? exploitation.production.value
                    : Number(field.value)
                }
              >
                {radioValuesOfExploitation.map((choice) => (
                  <FormControlLabel
                    key={choice.id}
                    control={<Radio color="primary" value={choice.id} />}
                    label={t(choice.phraseKey, {
                      defaultValue: choice.defaultValue,
                    })}
                  />
                ))}
              </RadioGroup>
            </FormControl>
          )}
        />
      </div>
    </div>
  );
}

export default PhotovoltaicAndExploitation;
